import VerifyEmailPage from "./verifyEmail";

export default VerifyEmailPage;